// import * as React from "react";
// import Box from "@mui/material/Box";
// import Tab from "@mui/material/Tab";
// import TabContext from "@mui/lab/TabContext";
// import TabList from "@mui/lab/TabList";
// import TabPanel from "@mui/lab/TabPanel";
// import PlacementRecords from "./PlacementRecords";
// import Recruiters from "./Recruiters";
// import Team from "./Team";
// import 'animate.css'
// import { useState } from "react";

// const Placement = () => {
//   const [value, setValue] = useState("0");
//     const [valueTab, setValueTab] = React.useState("one");
//     // const [value, setValue] = React.useState("1");

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };
//   const handleChangeTabs = (event, newValue) => {
//     setValueTab(newValue);
//   };
//   return (
//     <Box className="animate__animated animate__zoomIn" sx={{ width: "100%", typography: "body1", margin: "auto" }}>
//       <TabContext
//         value={value}
//         sx={{ width: "fit-content", textAlign: "center", margin: "auto" }}
//       >
//         <Box
//           sx={{
//             // borderBottom: 1,
//             borderColor: "divider",
//             width: "100%",
//             textAlign: "center",
//           }}
//         >
//           <TabList
//             centered
//             onChange={handleChange}
//             sx={{ width: "100%", textAlign: "center", minWidth: "0" }}
//             aria-label="lab API tabs example"
//           >
//             <Tab label="PLACEMENTS RECORDS" value="0" />
//             <Tab label="PLACEMENT TEAM" value="1" />
//             <Tab label="OUR RECRUITERS" value="2" />
//           </TabList>
//         </Box>
//         <TabPanel value="0">
//           <PlacementRecords />
//         </TabPanel>
//         <TabPanel value="1">
//           <Team />
//         </TabPanel>
//         <TabPanel value="2">
//           <Recruiters />
//         </TabPanel>
//       </TabContext>
//     </Box>
//   );
// };

// export default Placement;

// import * as React from "react";
// import Box from "@mui/material/Box";
// import Tab from "@mui/material/Tab";
// import TabContext from "@mui/lab/TabContext";
// import TabList from "@mui/lab/TabList";
// import TabPanel from "@mui/lab/TabPanel";
// import PlacementRecords from "./PlacementRecords";
// import Recruiters from "./Recruiters";
// import Team from "./Team";
// import 'animate.css';

// const Placement = () => {
//   const [value, setValue] = React.useState("0");
//   const [tabKey, setTabKey] = React.useState(0); 

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };

//   // Trigger re-render of TabContext after animation (300ms)
//   React.useEffect(() => {
//     const timer = setTimeout(() => {
//       setTabKey(prev => prev + 1); // trigger re-render
//     }, 1000); // match animation duration

//     return () => clearTimeout(timer);
//   }, []);

//   return (
//     <Box
//       className="animate__animated animate__zoomIn"
//       sx={{ width: "100%", typography: "body1", margin: "auto" }}
//     >
//       <TabContext key={tabKey} value={value}>
//         <Box
//           sx={{
//             borderColor: "divider",
//             width: "100%",
//             textAlign: "center",
//           }}
//         >
//           <TabList
//             centered
//             onChange={handleChange}
//             sx={{ width: "100%", textAlign: "center", minWidth: 0 }}
//             aria-label="lab API tabs example"
//           >
//             <Tab label="PLACEMENTS RECORDS" value="0" sx={{ minWidth: 0 }} />
//             <Tab label="PLACEMENT TEAM" value="1" sx={{ minWidth: 0 }} />
//             <Tab label="OUR RECRUITERS" value="2" sx={{ minWidth: 0 }} />
//           </TabList>
//         </Box>
//         <TabPanel value="0"><PlacementRecords /></TabPanel>
//         <TabPanel value="1"><Team /></TabPanel>
//         <TabPanel value="2"><Recruiters /></TabPanel>
//       </TabContext>
//     </Box>
//   );
// };

// export default Placement;

import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import PlacementRecords from "./PlacementRecords";
import Recruiters from "./Recruiters";
import Team from "./Team";

const Placement = () => {
  const [value, setValue] = React.useState("0");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", typography: "body1", margin: "auto" }}>
      <TabContext value={value}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            width: "100%",
            textAlign: "center",
          }}
        >
          <TabList
            centered
            onChange={handleChange}
            aria-label="Placement Tabs"
            sx={{ width: "100%", textAlign: "center" }}
          >
            <Tab label="PLACEMENTS RECORDS" value="0" />
            <Tab label="PLACEMENT TEAM" value="1" />
            <Tab label="OUR RECRUITERS" value="2" />
          </TabList>
        </Box>
        <TabPanel value="0">
          <PlacementRecords />
        </TabPanel>
        <TabPanel value="1">
          <Team />
        </TabPanel>
        <TabPanel value="2">
          <Recruiters />
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default Placement;


